import {getQuery as _getQuery, getMutation as _getMutation} from '@redux-requests/core';
import {apiAuth} from './auth';
import {apiHomepage} from './homepage';
import {apiProfile} from './profile';
import {apiRegister} from './register';
import {apiNotifications} from './notifications';
import {apiRecipes} from './recipes';
import {apiArticles} from './articles';
import {apiGifts} from './gifts';
import {apiPost} from './post';
import {apiProducts} from './products';
import {apiFormations} from './formations';
import {apiPasswordReset} from './passwordReset';

export const DEV_MODE = process.env.NODE_ENV === 'development';
export const API_URL = process.env.REACT_APP_API_URL;

export * from './interceptors';

export {default as query} from './query';
export {default as mutate} from './mutate';

export default {
  ...apiAuth,
  ...apiGifts,
  ...apiArticles,
  ...apiRegister,
  ...apiProfile,
  ...apiRecipes,
  ...apiFormations,
  ...apiNotifications,
  ...apiHomepage,
  ...apiPost,
  ...apiProducts,
  ...apiPasswordReset,
};

//export const getPostQuery = (s, action, requestKey) => _getQuery(s, {...action({}), requestKey});
export const getQuery = (s, action, requestKey) => _getQuery(s, {...action({}), requestKey});
export const getMutation = (s, action) => _getMutation(s, action());
